export const DELIVERY_METHODS = {
  homeDelivery: 'HOME_DELIVERY',
  pickupPoint: 'PICKUP_IN_PLACE',
  clickAndCollect: 'CLICK_AND_COLLECT',
  slowMode: 'SLOW_MODE',
  locker: 'LOCKER',
  timeSlotDelivery: 'TIME_SLOT_DELIVERY',
} as const

export enum DeliveryMethod {
  homeDelivery,
  pickupPoint,
  clickAndCollect,
}

export const DELIVERY_TITLES = {
  [DELIVERY_METHODS.homeDelivery]: {
    title: 'checkout.deliverto.homedelivery',
  },
  [DELIVERY_METHODS.pickupPoint]: {
    title: 'checkout.deliverto.pickupinplace',
  },
  [DELIVERY_METHODS.clickAndCollect]: {
    title: 'checkout.deliverto.clickandcollect',
  },
} as const

export const DELIVERY_METHODS_LIST_NUMBER = 4 as const

export const CELL_PHONE_DELIVERY_SECTION = 'CHECKOUTCUSTOMER.cellPhone.delivery.label.text' as const

export const DELIVERY_PHONE_NUMBER = 'phoneNumber' as const

export const INITIAL_PICKUP_PLACE_RESULTS_TO_SHOW = 4 as const
